import {
  ClientWorkFlowStatus,
  IPayableSchema
} from "@wingspanhq/payments/dist/interfaces";

export const selectorIsPayableRejected = (payable: IPayableSchema): boolean => {
  if (payable.client?.workflowStatus !== ClientWorkFlowStatus.Declined) {
    return false;
  }

  const { clientDeclinedAt, memberResubmittedAt } = payable.events ?? {};

  return (
    !memberResubmittedAt ||
    (!!clientDeclinedAt && clientDeclinedAt > memberResubmittedAt)
  );
};
